const FuzzyReaction = require('../bootstrap').FuzzyReaction;
const AppDispatcher = FuzzyReaction.Dispatcher;
const assign = require('object-assign');
const ModelStore = FuzzyReaction.Stores.ModelStore;

/**
 * Data stores
 * @type {Array}
 * @private
 */
let _allAlbums = [];

/**
 * User store logic
 *
 * @type {*|exports}
 */
const AlbumsStore = assign({}, ModelStore, {
    getAllAlbums: function () {
        return _allAlbums;
    }
});

/**
 * Event Listeners
 */
AlbumsStore.dispatchToken = AppDispatcher.register(function (action) {
    switch (action.type) {
        case 'ALBUMS_LISTED':
            _allAlbums = action.data;

            AlbumsStore.emitChange();
            break;
    }
});

module.exports = AlbumsStore;
